<!-- 选择列 -->
<template>
  <div class="select_col_container">
    <div class="btn_container">
      <el-tooltip
        class="box-item"
        effect="dark"
        placement="top"
        content="调整显隐和顺序"
      >
        <el-button circle icon="Menu" @click.stop="taggerShow" />
      </el-tooltip>
    </div>
    <el-card class="select_dialog_container" v-show="isShow" @click.stop>
      <el-scrollbar class="col-scrollbar">
        <el-tree
          ref="colTreeRef"
          :data="treeData"
          draggable
          show-checkbox
          node-key="label"
          :check-on-click-node="true"
          :default-checked-keys="defaultCheckedKeys"
          :allow-drop="onAllowDrop"
          @check-change="onCheckChange"
          @node-drag-start="onNodeDragStart"
          @node-drop="onNodeDrop"
        >
          <template #default="{ node }">
            <span>{{ node.label }}</span>
            <svg-icon iconClass="top-bottom-drag" class="tree-drag-icon" />
          </template>
        </el-tree>
      </el-scrollbar>
      <div class="mt5" style="float: right; padding-right: 5px">
        <div class="checkbox-container">
          <el-checkbox
            v-model="allOrReverse"
            ref="checkBoxRef"
            :label="checkLabel"
            :indeterminate="isIndeterminate"
            @change="handleCheckAllChange"
          />
        </div>

        <el-button @click="taggerShow">取消</el-button>
        <el-button @click="onSave" type="primary">保存</el-button>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { onMounted, ref, watch, onUnmounted, computed } from "vue";
import {
  deleteColConf,
  getColConfList,
  insertColConf,
  updateColConf,
} from "@/api/system/tableCol";
import { succesMsg } from "@/utils/msgBox.ts";
import eventBus from "@/utils/eventBus";
import useAccountStore from "@/store/modules/account";
import useSettingsStore from "@/store/modules/settings";

const accountStore = useAccountStore();
const settingsStore = useSettingsStore();

const props = defineProps({
  tableName: {
    // 表格的名字
    required: false,
    type: String,
    default: "",
  },
  allVals: {
    // 所有的列
    type: Array,
    required: false,
    default: [],
  },
});

const theme = ref(settingsStore.theme);

const colTreeRef = ref(null); // 表格列树控件
let isUserData = false;
let userData = {};
const resizeTableName = ref("");
const treeData = ref([]); // 树数据
const defaultCheckedKeys = ref([]); // 默认选择key
// 判断节点是否可以被拖拽到当前位置
const onAllowDrop = (draggingNode, gropNode, type) => {
  if (type === "inner") {
    return false;
  } else {
    return true;
  }
};

const selectNode = ref(null);
// 拖拽节点开始
const onNodeDragStart = () => {
  selectNode.value = colTreeRef.value.getCheckedKeys();
};
// 拖拽节点结束
const onNodeDrop = () => {
  colTreeRef.value.setCheckedKeys(selectNode.value);
  updateTableCol(); // 更新表格
};

const isShow = ref(false); // 是否显示选择列

const checkBoxRef = ref(null);
const isIndeterminate = ref(true);
const allOrReverse = ref(false);
const checkLabel = ref("全选");
let allCheckVals = [];

// 全选按钮改变
const handleCheckAllChange = (val, event) => {
  const checkKeys = val ? allCheckVals : [];
  colTreeRef.value.setCheckedKeys(checkKeys);
  isIndeterminate.value = false;
  if (val) {
    checkLabel.value = "取消";
  } else {
    checkLabel.value = "全选";
  }
};

// 切换显示状态
const taggerShow = () => {
  isShow.value = !isShow.value;
  updateTableCol();
};
const close = () => {
  isShow.value = false;
};
//

const emits = defineEmits(["updateTableCol"]);

// 保存数据
const onSave = (tip) => {
  if (resizeTableName.value && resizeTableName.value != props.tableName) return;
  const checkedDataList = colTreeRef.value.getCheckedKeys(); // 选中的数据
  if (isUserData) {
    // 修改数据
    const updateDataList = [];
    const newAddDataList = [];
    treeData.value.forEach((item, index) => {
      let colData = userData.find((uItem) => item.prop === uItem.columnDetail);
      if (colData) {
        // 修改配置
        colData.sort = index;
        if (checkedDataList.find((label) => item.label === label)) {
          // 显示
          colData.displayStatus = 1;
        } else {
          // 关闭
          colData.displayStatus = 0;
        }
        colData.columnWidth = item.itemWidth
          ? item.itemWidth
          : item.itemMinWidth;
        updateDataList.push(colData);
      } else {
        // 保存新增的配置
        let addCol = {
          userId: accountStore.userInfo.userId,
          funcId: props.tableName,
          sort: index,
          columnDetail: item.prop,
          columnWidth: item.itemWidth,
        };
        if (checkedDataList.find((label) => item.label === label)) {
          // 显示
          addCol.displayStatus = 1;
        } else {
          // 关闭
          addCol.displayStatus = 0;
        }
        newAddDataList.push(addCol);
      }
    });
    // 删除 去掉的列
    const delColData = [];
    userData.forEach((item) => {
      let notDelCol = treeData.value.find(
        (tItem) => tItem.prop === item.columnDetail
      );
      if (!notDelCol) {
        delColData.push(item);
      }
    });
    if (delColData.length > 0) {
      let delIds = delColData.map((item) => item.confId).join(",");
      deleteColConf(delIds);
    }
    updateColConf(updateDataList).then((resData) => {
      if (newAddDataList.length > 0) {
        insertColConf(newAddDataList).then((resData) => {
          succesMsg("保存成功");
        });
      } else {
        if (tip != true) {
          succesMsg("保存成功");
        }
      }
    });
  } else {
    // 新增数据
    const saveDataList = [];
    treeData.value.forEach((item, index) => {
      let colData = {
        userId: accountStore.userInfo.userId,
        funcId: props.tableName,
        sort: index,
        columnDetail: item.prop,
      };
      if (checkedDataList.find((label) => item.label === label)) {
        // 显示
        colData.displayStatus = 1;
      } else {
        // 关闭
        colData.displayStatus = 0;
      }
      saveDataList.push(colData);
    });
    insertColConf(saveDataList).then((resData) => {
      succesMsg("保存成功");
      getUserTableCol();
    });
  }
};

// 获取用户表格列
const getUserTableCol = () => {
  getColConfList(accountStore.userInfo.userId, props.tableName).then(
    (resData) => {
      if (
        props.tableName === "" ||
        resData.data === null ||
        resData.data.length === 0
      ) {
        // 用户数据为空
        treeData.value = props.allVals;
        defaultCheckedKeys.value = treeData.value.map((item) => item.label);
        // 全选框设置
        allCheckVals = defaultCheckedKeys.value; // 所有选择像
        checkLabel.value = "取消";
        isIndeterminate.value = false;
        allOrReverse.value = true;

        // updateTableCol(props.allVals)
      } else {
        // 获取到用户数据
        userData = resData.data;
        const userTreeData = []; // 用户表格列数据
        const chekcedKeys = []; // 选中的数据
        const checkTableCol = [];
        const delColData = []; // 删除重复的列
        userData.forEach((item) => {
          let colItem = props.allVals.find(
            (citem) => item.columnDetail === citem.prop
          );
          if (item.columnWidth && colItem) {
            colItem.itemWidth = item.columnWidth;
            colItem.noMinWidth = true;
          }
          if (colItem) {
            // 在属性所有的列中找到当前值，没有找到，可能是删除当前列，不进行显示
            let isInUserTreeData = userTreeData.find(
              (uItem) => uItem.prop === colItem.prop
            );
            if (isInUserTreeData) {
              // 存在重复数据
              delColData.push(item);
            } else {
              // 不存在重复数据，加入到用户显示树中
              if (colItem) {
                userTreeData.push(colItem);
                if (item.displayStatus === "1") {
                  chekcedKeys.push(colItem.label);
                  checkTableCol.push(colItem);
                }
              }
            }
          }
        });
        props.allVals.forEach((item) => {
          let colItem = userTreeData.find((citem) => item.prop === citem.prop);
          if (!colItem) {
            userTreeData.push(item);
          }
        });
        treeData.value = userTreeData;
        defaultCheckedKeys.value = chekcedKeys;
        isUserData = true;
        updateTableCol(checkTableCol);

        // 全选框设置
        allCheckVals = treeData.value.map((item) => item.label); // 所有选择像
        if (defaultCheckedKeys.value.length === 0) {
          checkLabel.value = "全选";
          isIndeterminate.value = false;
          allOrReverse.value = false;
        } else if (defaultCheckedKeys.value.length >= allCheckVals.length) {
          checkLabel.value = "取消";
          isIndeterminate.value = false;
          allOrReverse.value = true;
        } else {
          checkLabel.value = "选择";
          isIndeterminate.value = true;
          allOrReverse.value = false;
        }

        // 删除重复的列
        if (delColData.length > 0) {
          let delIds = delColData.map((item) => item.confId).join(",");
          deleteColConf(delIds);
        }
      }
    }
  );
};

// 更新表格列
const updateTableCol = (tableCol) => {
  if (tableCol) {
    // eventBus.emit("updateTableCol",tableCol)
    emits("updateTableCol", tableCol);
  } else {
    emits("updateTableCol", colTreeRef.value.getCheckedNodes());
  }
};
// 列选项改变，更新表格的列
const onCheckChange = (vals, val) => {
  const checkNodes = colTreeRef.value.getCheckedNodes();
  updateTableCol(checkNodes);
  if (checkNodes.length === 0) {
    checkLabel.value = "全选";
    isIndeterminate.value = false;
    allOrReverse.value = false;
  } else if (checkNodes.length === allCheckVals.length) {
    checkLabel.value = "取消";
    isIndeterminate.value = false;
    allOrReverse.value = true;
  } else {
    checkLabel.value = "选择";
    isIndeterminate.value = true;
    allOrReverse.value = false;
  }
};

onMounted(() => {
  getUserTableCol();
  watch(
    () => isShow.value,
    (newVal) => {
      if (newVal) {
        document.body.addEventListener("click", close, { passive: false });
      } else {
        document.body.removeEventListener("click", close);
      }
    }
  );
  watch(
    () => settingsStore.theme,
    (newVal) => {
      theme.value = newVal;
    }
  );
});

// 更新表格列顺序
const updateColOrder = (param) => {
  close();
  const { reverseOrder, dragCol, endCol } = param;
  const length = treeData.value.length;
  let index = 0;
  if (reverseOrder) {
    index = length - 1;
  }
  let loopFlag = true;
  if (length === 0) {
    loopFlag = false;
  }
  let dragColItem = null;
  const newTreeData = [];
  while (loopFlag) {
    const colItem = treeData.value[index];
    if (colItem.prop === dragCol) {
      dragColItem = colItem;
    } else if (dragColItem !== null && colItem.prop === endCol) {
      newTreeData.push(colItem);
      newTreeData.push(dragColItem);
    } else {
      newTreeData.push(colItem);
    }
    if (reverseOrder) {
      // 倒序
      index -= 1;
      if (index < 0) {
        loopFlag = false;
      }
    } else {
      // 正序
      index += 1;
      if (index >= length) {
        loopFlag = false;
      }
    }
  }
  if (reverseOrder) {
    newTreeData.reverse();
  }
  treeData.value = newTreeData;
  // onSave(true);
  /**
   * 此处由于更改树数据之后无法触发 el-tree 组件数据的更改，需要显示后才能触发，此处先手写方法更新表格列数据
   */
  onSave();
  manualUpdateTableCol();
};

const manualUpdateTableCol = () => {
  const checkNode = colTreeRef.value.getCheckedNodes();
  const checkNodeKeyList = checkNode.map((item) => item.prop);
  const updateCheckNode = [];
  treeData.value.forEach((item) => {
    if (checkNodeKeyList.includes(item.prop)) {
      updateCheckNode.push(item);
    }
  });
  emits("updateTableCol", updateCheckNode);
};

defineExpose({
  save: onSave,
  updateColOrder: updateColOrder,
});
</script>

<style lang="scss" scoped>
.select_col_container {
  display: inline-block;
  position: relative;

  .btn_container {
    .el-button--small {
      padding: 2px 2px;
      width: 42px;
    }
  }

  .select_dialog_container {
    position: absolute;
    z-index: 1000;
    width: 200px;
    height: 355px;
    left: -160px;
    background-color: white;

    :deep(.el-card__body) {
      padding: 0px !important;
    }

    .checkbox-container {
      display: inline-block;
      width: 60px;
      :deep(.el-checkbox__label) {
        min-width: 30px;
      }
    }

    .col-scrollbar {
      height: 300px;
    }

    :deep(.el-checkbox__label) {
      min-width: 150px;
    }

    .el-card__body {
      padding-left: 0px !important;
      .el-tree-node {
        .el-tree-node__content {
          min-width: 200px;

          .el-tree-node__expand-icon {
            margin-left: 10px;
          }
        }
        .el-tree-node__content .tree-drag-icon {
          display: none !important;
        }
        .el-tree-node__content:hover .tree-drag-icon {
          display: block !important;
          left: 7px;
          position: absolute;
          color: v-bind(theme);
        }
      }
    }
  }

  .detail-card {
    position: absolute;
    top: -1500px;
    left: -1500px;
    width: 3000px;
    height: 3000px;
    //background-color: red;
    z-index: 99;
  }
}
</style>
